import { render, staticRenderFns } from "./NewArrivalBadge.vue?vue&type=template&id=00f5e848&scoped=true&"
import script from "./NewArrivalBadge.vue?vue&type=script&lang=js&"
export * from "./NewArrivalBadge.vue?vue&type=script&lang=js&"
import style0 from "./NewArrivalBadge.vue?vue&type=style&index=0&id=00f5e848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5e848",
  null
  
)

export default component.exports